import { useEffect, useState } from 'react';
import type { FormValues } from '@/features/tai-san/khai-bao-thoi-khau-hao-tscd/schema';
import { TaiSanCoDinh, TaiSanCoDinhResponse } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import api from '@/lib/api';

interface UseTaiSanCoDinhReturn {
  khaiBaoThoiKhauHaoTSCDs: TaiSanCoDinh[];
  isLoading: boolean;
  updateKhaiBaoThoiKhauHaoTSCD: (uuid: string, updatedProvince: any) => Promise<void>;
  refreshKhaiBaoThoiKhauHaoTSCD: () => Promise<void>;
}

export const useKhaiBaoThoiKhauHaoTSCD = (initialData: TaiSanCoDinh[] = []): UseTaiSanCoDinhReturn => {
  const [khaiBaoThoiKhauHaoTSCDs, setKhaiBaoThoiKhauHaoTSCD] = useState<TaiSanCoDinh[]>(initialData);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { entity } = useAuth();

  const fetchKhaiBaoThoiKhauHaoTSCD = async (): Promise<void> => {
    if (!entity?.slug) return;

    setIsLoading(true);
    const response = await api.get<TaiSanCoDinhResponse>(
      `/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_THOI_KHAU_HAO_TSCD}/`
    );

    const mappedData: TaiSanCoDinh[] = response.data.results;

    setKhaiBaoThoiKhauHaoTSCD(mappedData);
    setIsLoading(false);
  };

  const updateKhaiBaoThoiKhauHaoTSCD = async (uuid: string, updatedProvince: FormValues) => {
    if (!entity?.slug) return;

    setIsLoading(true);
    const response = await api.put(`/entities/${entity.slug}/erp/${QUERY_KEYS.KHAI_BAO_THOI_KHAU_HAO_TSCD}/${uuid}/`, {
      ma_ts: updatedProvince.ma_ts,
      ten_ts: updatedProvince.ten_ts,
      ngay_kh1: updatedProvince.ngay_kh1
    });

    // Update the province in the list
    const updatedProvinceData: TaiSanCoDinh = response.data;

    setKhaiBaoThoiKhauHaoTSCD(prev =>
      prev.map(province => (province.uuid === updatedProvinceData.uuid ? updatedProvinceData : province))
    );
    setIsLoading(false);
  };

  useEffect(() => {
    fetchKhaiBaoThoiKhauHaoTSCD();
  }, [entity?.slug]);

  return {
    khaiBaoThoiKhauHaoTSCDs,
    isLoading,
    updateKhaiBaoThoiKhauHaoTSCD,
    refreshKhaiBaoThoiKhauHaoTSCD: fetchKhaiBaoThoiKhauHaoTSCD
  };
};
